import { ADD_BRAND_PRODUCT_ON_SUCCESS } from 'root/src/client/logic/tableItem/actionIds'

export default payload => ({
	type: ADD_BRAND_PRODUCT_ON_SUCCESS,
	payload,
})
